// extracted by mini-css-extract-plugin
export default {"mealTable":"ek2Pt3fByuUMG4NEoi2g"};